import { getSelectedCountry, getSelectedRegion } from './helpers';
import { useCallback, useEffect, useState } from 'react';

import { FormikValues, useFormikContext } from 'formik';
import { LocationDataRegion } from '@alluradirect/react';
import { NameIdItem } from '@alluradirect/react';

interface Args {
  regions: LocationDataRegion[];
  countries: NameIdItem[];
  formikAddressValue: FormikValues;
  formikPrefix: string;
}

export const useAddressForm = ({ regions, countries, formikAddressValue, formikPrefix = '' }: Args) => {
  const { setFieldValue } = useFormikContext<any>();
  const [filteredRegions, setFilteredRegions] = useState(regions);
  const [selectedCountry, setSelectedCountry] = useState({ NAME: '', ID: 0 });
  const [selectedRegion, setSelectedRegion] = useState({ NAME: '', ID: 0, COUNTRY_ID: 0 });

  const addressPrefix = `${formikPrefix}ADDRESS.`;

  const resetRegion = useCallback(() => {
    setFieldValue(`${addressPrefix}REGION`, '');
    setFieldValue(`${addressPrefix}REGION_ID`, 0);
  }, [addressPrefix, setFieldValue]);

  const handleRegionSelect = useCallback(
    (_e: any, newValue: any) => {
      if (newValue) {
        setFieldValue(`${addressPrefix}REGION`, newValue.NAME);
        setFieldValue(`${addressPrefix}REGION_ID`, newValue.ID);
      } else {
        resetRegion();
      }
    },
    [addressPrefix, resetRegion, setFieldValue],
  );

  const handleCountrySelect = useCallback(
    (_e: any, newValue: any) => {
      resetRegion();
      if (newValue) {
        setFieldValue(`${addressPrefix}COUNTRY`, newValue.NAME);
        setFieldValue(`${addressPrefix}COUNTRY_ID`, newValue.ID);
      } else {
        setFieldValue(`${addressPrefix}COUNTRY`, '');
        setFieldValue(`${addressPrefix}COUNTRY_ID`, 0);
      }
    },
    [addressPrefix, resetRegion, setFieldValue],
  );

  useEffect(() => {
    if (!countries) return;

    const selectedCountry = getSelectedCountry(formikAddressValue.COUNTRY, countries);

    setSelectedCountry(selectedCountry);
    if (selectedCountry.ID === 0) {
      setFilteredRegions(regions);
    } else {
      setFilteredRegions(regions.filter(region => region.COUNTRY_ID === selectedCountry.ID));
    }
  }, [formikAddressValue, regions, countries]);

  useEffect(() => {
    if (!regions) return;

    setSelectedRegion(getSelectedRegion(formikAddressValue.REGION, regions));
  }, [formikAddressValue, regions]);

  return { filteredRegions, selectedCountry, selectedRegion, handleRegionSelect, handleCountrySelect };
};
